/**
 * Single source of truth for layer/source colors used across the platform.
 *
 * Future phases must reference these constants rather than re-introducing
 * raw hex literals. Marker palette (the small dots themselves) is still
 * hardcoded inside MapView until the drone phase lands and forces a
 * cohesive marker scheme — see the Phase C.2 status report.
 */

/** sky-blue — snapshot cameras (Phase C/C.1/C.2). */
export const COVERAGE_SNAPSHOT = '#38bdf8';

/** green — live cameras (Phase D). */
export const COVERAGE_LIVE = '#22c55e';

/** yellow — drone coverage (later phase). */
export const COVERAGE_DRONE = '#fbbf24';

/** purple — weather stations (QA / raw data layer). */
export const SENSOR_WEATHER = '#a78bfa';
